import { useCallback } from 'react'
import { useGraphTransactionsSWR } from 'modules/network/fetchers/fetchTransactions'

import { Button } from 'shared/ui/controls/Button'
import { PageLoader } from 'shared/ui/layout/PageLoader'
import { TransactionsTable } from 'modules/transactions/ui/TransactionsTable'

import type { TableSortState } from 'shared/ui/common/Table'
import { createRoute } from 'modules/router/utils/createRoute'

function RouteTransactionList() {
  const { data, isLoading, isValidating, loadMore, hasMore, setSortDir } =
    useGraphTransactionsSWR()

  const handleChangeSort = useCallback(
    (s: TableSortState) => setSortDir(s[1] === -1 ? 'asc' : 'desc'),
    [setSortDir],
  )

  if (isLoading) {
    return <PageLoader />
  }

  return (
    <>
      <TransactionsTable data={data} onChangeSort={handleChangeSort} />
      {hasMore && (
        <Button
          size={60}
          isCentered
          onClick={loadMore}
          fashion="secondary"
          isLoading={isValidating}
          children="Load more"
        />
      )}
    </>
  )
}

export const routeTransactionList = createRoute({
  headerTitle: 'Transactions',
  layoutType: 'default',
  component: RouteTransactionList,
  checkConnect: true,
})
